import { appConfigKey } from "../../../../config/Config";
import { ValidationQuatitionMemberStepOneDataInteface, ValidationQuatitionMemberStepTwoDataInteface } from "../interfaces/validationQuatitionMember";

const ValidacionStepTwoHelper = {

    NewBlackListGesintel: (blackListGesintel: any) => {
        let entityBlackListGesintel: any = {};

        if ((blackListGesintel.filter((x: any) => x.esObservadoPlaftYRiesgo).length > 0) ||
            (blackListGesintel.filter((x: any) => x.esObservadoRiesgos).length > 0 &&
                blackListGesintel.filter((x: any) => x.esObservadoPlaft).length > 0)) {
            entityBlackListGesintel = {
                mensaje: appConfigKey.keyMsjClienteListaNegraYGesintel.replace('[CAMPO]', 'PLAFT y RIESGOS'),
                esObservadoPlaftYRiesgo: true,
                esObservadoRiesgos: false,
                esObservadoPlaft: false
            }
            return entityBlackListGesintel;

        } else if (blackListGesintel.filter((x: any) => x.esObservadoRiesgos).length > 0) {
            entityBlackListGesintel = {
                mensaje: appConfigKey.keyMsjClienteListaNegraYGesintel.replace('[CAMPO]', 'RIESGOS'),
                esObservadoPlaftYRiesgo: false,
                esObservadoRiesgos: true,
                esObservadoPlaft: false
            }
            return entityBlackListGesintel;

        } else {
            entityBlackListGesintel = {
                mensaje: appConfigKey.keyMsjClienteListaNegraYGesintel.replace('[CAMPO]', 'PLAFT'),
                esObservadoPlaftYRiesgo: false,
                esObservadoRiesgos: false,
                esObservadoPlaft: true
            }
            return entityBlackListGesintel;
        }
    },

    NewModelicaData: (response: any) => {
        let mensajeModelica = "";

        if (!response) {
            mensajeModelica = 'Error en la consulta del Motor';
            return mensajeModelica;
        }

        const { data } = response;

        if (!data?.isValid || !data?.content) {
            mensajeModelica = 'Error en la consulta del Motor';
            return mensajeModelica;
        }

        const responseModelica = JSON.parse(data.content);
        if (!responseModelica.response?.Politica_Creditos) {
            mensajeModelica = responseModelica.response?.error?.message ?? 'Error en la consulta del Motor';
            return mensajeModelica;
        }

        return mensajeModelica;
    },

    ModelicaDecision: (response: any) => {
        let validacion: { decision: string | null | number, mensajeModelica: any[] | null, derivacion: number } = { decision: null, mensajeModelica: null, derivacion: 0 };

        let jsonResponseModelica = JSON.parse(response?.data?.content);

        let decision = jsonResponseModelica?.response?.Politica_Creditos?.decision_Credito?.decision;
        let mesaCreditos = jsonResponseModelica?.response?.Politica_Creditos?.decision_Credito?.mesa_Creditos;
        let motivoRechazo = jsonResponseModelica?.response?.Politica_Creditos?.motivo_Rechazo;
        let mensajes = [];

        const msgDecision = '- Decisión del crédito:';
        const msgMotivo = '- Motivo:';

        validacion.decision = decision;
        //if (decision === appConfigKey.CodigoEvaluacionZonaGris) {
        if (mesaCreditos.derivacion === appConfigKey.CodigoDerivacion) {
            //mensajes.push(`${msgDecision} ${appConfigKey.CodigoEvaluacionZonaGrisDescripcion}`);

            validacion.derivacion = appConfigKey.CodigoDerivacion;

            if (mesaCreditos?.motivo_Derivacion) {
                const detalleZonaGris = mesaCreditos?.motivo_Derivacion.map((det: any, index: number) => `${det?.detalle}`);
                mensajes.push(`${msgMotivo} ${detalleZonaGris.join(", ")}`);
            }
        }

        if (decision === appConfigKey.CodigoEvaluacionRechazado) {
            mensajes.push('La cotización ha sido rechazada, revise la información del cliente y/o condiciones del financiamiento para que pueda aplicar al crédito.');
            mensajes.push(`${msgDecision} ${appConfigKey.CodigoEvaluacionRechazadoDescripcion}`);

            if (motivoRechazo?.Detalle) {
                const detalleRechazo = motivoRechazo.Detalle.map((det: any, index: number) => `${det?.descripcion} ${(det?.interviniente ? ' del ' + det?.interviniente : '')}`);
                mensajes.push(`${msgMotivo} ${detalleRechazo.join(", ")}`);
            }
        }

        if (mensajes.length > 0) {
            
            if (decision === appConfigKey.CodigoEvaluacionRechazado) {
                mensajes.unshift(appConfigKey.keyMsjModelicaObservado.replace("[CAMPO]", appConfigKey.keyMsjModelicaObservadoDecision));
            }

            validacion.mensajeModelica = mensajes?.map((msg: any, index: number) => (
                <div key={index} style={{ marginBottom: index === 0 ? '10px' : '0' }}>
                    {msg}
                </div>
            ));
            
        }

        return validacion;
    },

    BlackListGesintel: (blackListGesintel: any): JSX.Element[] | undefined => {
        let mensaje;
        let entityBlackListGesintel = null;
        let validacionMensajes: string[] = [];

        if (blackListGesintel && blackListGesintel.length > 0) {
            if ((blackListGesintel.filter((x: any) => x.esObservadoPlaftYRiesgo).length > 0) ||
                (blackListGesintel.filter((x: any) => x.esObservadoRiesgos).length > 0 &&
                    blackListGesintel.filter((x: any) => x.esObservadoPlaft).length > 0)) {
                entityBlackListGesintel = {
                    mensaje: appConfigKey.keyMsjClienteListaNegraYGesintelCotizacion.replace('[CAMPO]', 'PLAFT y RIESGOS'),
                    esObservadoPlaftYRiesgo: true,
                    esObservadoRiesgos: false,
                    esObservadoPlaft: false
                }
            } else if (blackListGesintel.filter((x: any) => x.esObservadoRiesgos).length > 0) {
                entityBlackListGesintel = {
                    mensaje: appConfigKey.keyMsjClienteListaNegraYGesintelCotizacion.replace('[CAMPO]', 'RIESGOS'),
                    esObservadoPlaftYRiesgo: false,
                    esObservadoRiesgos: true,
                    esObservadoPlaft: false
                }
            } else {
                entityBlackListGesintel = {
                    mensaje: appConfigKey.keyMsjClienteListaNegraYGesintelCotizacion.replace('[CAMPO]', 'PLAFT'),
                    esObservadoPlaftYRiesgo: false,
                    esObservadoRiesgos: false,
                    esObservadoPlaft: true
                }
            }

            //Obtener detalle de observación por miembro
            blackListGesintel.forEach((member: any) => {
                let tipoRelacionDescription = "";
                let observacionMensaje = "";

                if (member.tipoRelacionId == appConfigKey.KeyIdTipoRelacionTitular) {
                    tipoRelacionDescription = appConfigKey.KeyIdTipoRelacionTitularDescripcion;
                } else if (member.tipoRelacionId == appConfigKey.KeyIdTipoRelacionConyuge) {
                    tipoRelacionDescription = appConfigKey.KeyIdTipoRelacionConyugeDescripcion;
                } else if (member.tipoRelacionId == appConfigKey.KeyIdTipoRelacionEmpresa) {
                    tipoRelacionDescription = `${appConfigKey.KeyIdTipoRelacionEmpresaDescripcion2} ${member.numeroDocumento?.trim()}`;
                } else if (member.tipoRelacionId == appConfigKey.KeyIdTipoRelacionFiador) {
                    tipoRelacionDescription = `${appConfigKey.KeyIdTipoRelacionFiadorDescripcion} ${member.numeroDocumento?.trim()}`;
                } else if (member.tipoRelacionId == appConfigKey.KeyIdTipoRelacionFiadorConyuge) {
                    tipoRelacionDescription = `${appConfigKey.KeyIdTipoRelacionFiadorConyugeDescripcion} ${member.numeroDocumento?.trim()}`;
                } else if (member.tipoRelacionId == appConfigKey.KeyIdTipoRelacionCompraPara) {
                    tipoRelacionDescription = appConfigKey.KeyIdTipoRelacionCompraParaDescripcion;
                } else if (member.tipoRelacionId == appConfigKey.KeyIdTipoRelacionCompraParaConyuge) {
                    tipoRelacionDescription = appConfigKey.KeyIdTipoRelacionCompraParaConyugeDescripcion;
                } else if (member.tipoRelacionId == appConfigKey.KeyIdTipoRelacionEjecutivo) {
                    tipoRelacionDescription = appConfigKey.KeyIdTipoRelacionEjecutivoDescripcion;
                } else if (member.tipoRelacionId == appConfigKey.KeyIdTipoRelacionConcesionario) {
                    tipoRelacionDescription = appConfigKey.KeyIdTipoRelacionConcesionarioDescripcion;
                } else if (member.tipoRelacionId == appConfigKey.KeyIdTipoRelacionVendedor) {
                    tipoRelacionDescription = appConfigKey.KeyIdTipoRelacionVendedorDescripcion;
                }

                if (member.bantotalObservado && member.gesintelObservado) {
                    observacionMensaje = `${appConfigKey.keyMsjBaseNegativa} / ${appConfigKey.keyMsjBaseGesintel}`
                } else if (member.bantotalObservado) {
                    observacionMensaje = `${appConfigKey.keyMsjBaseNegativa}`
                } else if (member.gesintelObservado) {
                    observacionMensaje = `${appConfigKey.keyMsjBaseGesintel}`
                }

                validacionMensajes.push(`- ${tipoRelacionDescription} ${observacionMensaje}`)
            });
        }

        if (entityBlackListGesintel) {
            //Observado por lista negra o gesintel
            validacionMensajes.unshift(`${entityBlackListGesintel.mensaje}.`);
        }

        if (validacionMensajes.length > 0) {
            mensaje = validacionMensajes?.map((msg: string, index: number) => (
                <div key={index} style={{ marginBottom: index === 0 ? '10px' : '0' }}>
                    {msg}
                </div>
            ));
        }

        return mensaje;
    },

    GetMembersStepTwoData: (
        state: any,
        executiveData: any,
        partnerData: any,
    ) => {
        let validateMembers: ValidationQuatitionMemberStepTwoDataInteface[] = []
        let idCotizacion = state?.quotationIdentificador;

        if (state?.nroDocumentoTitular) {
            let member = {
                IdCotizacion: idCotizacion,
                TipoRelacionId: appConfigKey.KeyIdTipoRelacionTitular,
                TipoDocumento: state.selectedTipoDocTitular,
                NumeroDocumento: state.nroDocumentoTitular
            } as ValidationQuatitionMemberStepOneDataInteface
            validateMembers.push(member);
        }
        
        if (state?.nroDocumentoConyuge &&
            state?.selectedEstadoCivil == appConfigKey.keyIdEstadoCivilCasado &&
            !state?.separacionBienes
        ) {
            let member = {
                IdCotizacion: idCotizacion,
                TipoRelacionId: appConfigKey.KeyIdTipoRelacionConyuge,
                TipoDocumento: state.selectedTipoDocTitularConyuge,
                NumeroDocumento: state.nroDocumentoConyuge
            } as ValidationQuatitionMemberStepOneDataInteface
            validateMembers.push(member);
        }

        if (state?.listOtrosIngresosTitular && state?.listOtrosIngresosTitular.length >= 1) {
            let member = {
                IdCotizacion: idCotizacion,
                TipoRelacionId: appConfigKey.KeyIdTipoRelacionEmpresa,
                TipoDocumento: appConfigKey.keyIdRUC,
                NumeroDocumento: state.listOtrosIngresosTitular[0].nroRuc
            } as ValidationQuatitionMemberStepOneDataInteface
            validateMembers.push(member);

            if (state.listOtrosIngresosTitular.length >= 2) {
                const listaOtrosTrabajos = state.listOtrosIngresosTitular.slice(1);

                for (let rowOtroTrabajo of listaOtrosTrabajos) {
                    let member = {
                        IdCotizacion: idCotizacion,
                        TipoRelacionId: appConfigKey.KeyIdTipoRelacionEmpresa,
                        TipoDocumento: appConfigKey.keyIdRUC,
                        NumeroDocumento: rowOtroTrabajo.nroRuc
                    } as ValidationQuatitionMemberStepOneDataInteface
                    validateMembers.push(member);
                }
            }
        }

        if (state?.selectedEstadoCivil == appConfigKey.keyIdEstadoCivilCasado &&
            !state?.separacionBienes &&
            state?.listOtrosIngresosConyuge &&
            state?.listOtrosIngresosConyuge.length >= 1 &&
            state?.listOtrosIngresosConyuge[0].idCategoria != appConfigKey.keyIdSinCategoria) {
            let member = {
                IdCotizacion: idCotizacion,
                TipoRelacionId: appConfigKey.KeyIdTipoRelacionEmpresa,
                TipoDocumento: appConfigKey.keyIdRUC,
                NumeroDocumento: state.listOtrosIngresosConyuge[0].nroRuc
            } as ValidationQuatitionMemberStepOneDataInteface
            validateMembers.push(member);

            if (state.listOtrosIngresosConyuge.length >= 2) {
                const listaOtrosTrabajos = state.listOtrosIngresosConyuge.slice(1);
                for (let rowOtroTrabajo of listaOtrosTrabajos) {
                    let member = {
                        IdCotizacion: idCotizacion,
                        TipoRelacionId: appConfigKey.KeyIdTipoRelacionEmpresa,
                        TipoDocumento: appConfigKey.keyIdRUC,
                        NumeroDocumento: rowOtroTrabajo.nroRuc
                    } as ValidationQuatitionMemberStepOneDataInteface
                    validateMembers.push(member);
                }
            }
        }

        if (executiveData) {
            let member = {
                IdCotizacion: idCotizacion,
                TipoRelacionId: appConfigKey.KeyIdTipoRelacionEjecutivo,
                TipoDocumento: executiveData.iD_TIPO_DOCUMENTO,
                NumeroDocumento: executiveData.nrO_DOCUMENTO
            } as ValidationQuatitionMemberStepTwoDataInteface
            validateMembers.push(member);
        }

        if (partnerData) {
            if (partnerData.datosPartner) {
                let concesionarioMember = {
                    IdCotizacion: idCotizacion,
                    TipoRelacionId: appConfigKey.KeyIdTipoRelacionConcesionario,
                    TipoDocumento: partnerData.datosPartner.tipoDocumento,
                    NumeroDocumento: partnerData.datosPartner.numeroDocumento
                } as ValidationQuatitionMemberStepTwoDataInteface
                validateMembers.push(concesionarioMember);
            }

            if (partnerData.datosVendedor) {
                let vendedorMember = {
                    IdCotizacion: idCotizacion,
                    TipoRelacionId: appConfigKey.KeyIdTipoRelacionVendedor,
                    TipoDocumento: partnerData.datosVendedor.tipoDocumento,
                    NumeroDocumento: partnerData.datosVendedor.numeroDocumento
                } as ValidationQuatitionMemberStepTwoDataInteface
                validateMembers.push(vendedorMember);
            }
        }

        //Remover miembros repetidos
        const claves = new Set<string>();
        validateMembers = validateMembers.filter(m => {
            const clave = `${m.IdPersona}-${m.TipoRelacionId}-${m.TipoDocumento}-${m.NumeroDocumento}`;
            if (!claves.has(clave)) {
                claves.add(clave);
                return true;
            }
            return false;
        });

        // Remover miembros inválidos
        validateMembers = validateMembers.filter(m =>
            m.TipoDocumento &&
            m.NumeroDocumento
        );

        return validateMembers;
    }


};

export default ValidacionStepTwoHelper;